export default [
  {
    path: '/form-pendaftaran-komlabs',
    name: 'form-pendaftaran-komlabs',
    component: () => import('@/views/pages/komlabs/form/KomlabsRegistration.vue'),
    meta: {
      resource: 'Komlabs - Form',
      action: 'manage',
    },
  },
  {
    path: '/komlabs/kategori',
    name: 'kategori-komlabs',
    component: () => import('@/views/pages/komlabs/settings/kategori/Page.vue'),
    meta: {
      resource: 'Komlabs - Form',
      action: 'manage',
    },
  },
  {
    path: '/komlabs/creator-data',
    name: 'creator-data-komlabs',
    component: () => import('@/views/pages/komlabs/creator-management/creator-data/Page.vue'),
    meta: {
      resource: 'Komlabs - Creator Management',
      action: 'manage',
    },
  },
  {
    path: '/komlabs/creator-distribution',
    name: 'creator-distribution-komlabs',
    component: () => import('@/views/pages/komlabs/creator-management/creator-distribution/Page.vue'),
    meta: {
      resource: 'Komlabs - Creator Management',
      action: 'manage',
    },
  },
  {
    path: '/komlabs/upgrade-status',
    name: 'upgrade-status-komlabs',
    component: () => import('@/views/pages/komlabs/creator-management/upgrade-status/Page.vue'),
    meta: {
      resource: 'Komlabs - Creator Management',
      action: 'manage',
    },
  },
  {
    path: '/komlabs/campaign-list',
    name: 'campaign-list-komlabs',
    component: () => import('@/views/pages/komlabs/campaign-management/campaign-list/Page.vue'),
    meta: {
      resource: 'Komlabs - Campaign Management',
      action: 'manage',
    },
  },
  {
    path: '/komlabs/campaign-detail/:id',
    name: 'campaign-detail-komlabs',
    component: () => import('@/views/pages/komlabs/campaign-management/detail-campaign/Page.vue'),
    meta: {
      resource: 'Komlabs - Campaign Management',
      action: 'manage',
      navActiveLink: 'campaign-list-komlabs',
    },
  },
  {
    path: '/komlabs/create-campaign',
    name: 'create-campaign-komlabs',
    component: () => import('@/views/pages/komlabs/campaign-management/create-campaign/Page.vue'),
    meta: {
      resource: 'Komlabs - Campaign Management',
      action: 'manage',
      navActiveLink: 'campaign-list-komlabs',
    },
  },
  {
    path: '/komlabs/edit-campaign/:id',
    name: 'edit-campaign-komlabs',
    component: () => import('@/views/pages/komlabs/campaign-management/edit-campaign/Page.vue'),
    meta: {
      resource: 'Komlabs - Campaign Management',
      action: 'manage',
      navActiveLink: 'campaign-list-komlabs',
    },
  },
]
